(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-notifications-checker/assets/javascripts/player-notifications-checker.js') >= 0) return;  svs.modules.push('/components/accountservices/player-notifications-checker/assets/javascripts/player-notifications-checker.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.player_notifications_checker = svs.accountservices.player_notifications_checker || {};
const logger = svs.core.log.getLogger('accountservices:player-notifications-checker');
const playerNotificationsCheckerEvents = new svs.utils.Events({});
let customerSettings = {};
const reminderTypes = {
  emailNotVerified: 1,
  cellphoneNotVerified: 2,
  emailAndCellphoneNotVerified: 3,
  emailMissing: 4,
  emailBounced: 5
};
let shownTypes = [];
let refreshRetries = 0;
const refreshMaxRetries = 5;
const refreshRetryDelay = 800;
let oldCustomerSettings = {};

function remindLaterSet(type) {
  return Boolean(svs.core.session.data.userSession.data.playerNotifs_remindLater && _.find(svs.core.session.data.userSession.data.playerNotifs_remindLater, reminderType => type == reminderType));
}

function isShown(type) {
  if (type == reminderTypes.emailMissing) {
    return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailMissing == shownType) !== undefined;
  } else if (type == reminderTypes.emailBounced) {
    return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailBounced == shownType) !== undefined;
  } else if (type == reminderTypes.emailNotVerified) {
    return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailNotVerified == shownType || reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
  } else if (type == reminderTypes.cellphoneNotVerified) {
    return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.cellphoneNotVerified == shownType || reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
  }
  return Boolean(shownTypes) && _.find(shownTypes, shownType => reminderTypes.emailAndCellphoneNotVerified == shownType) !== undefined;
}

function mapCustomerSettingsForSave() {
  const debugObject = {
    emailRemoved: customerSettings.emailRemoved ? 1 : 0,
    emailBounce: customerSettings.emailBounce ? 1 : 0,
    emailVerified: customerSettings.emailVerified ? 1 : 0,
    cellPhoneVerified: customerSettings.cellPhoneVerified ? 1 : 0,
    cellPhoneExists: customerSettings.cellPhoneExists ? 1 : 0
  };
  logger.debug("Save data to userSession: ".concat(JSON.stringify(debugObject)));
  return {
    a: customerSettings.emailRemoved ? 1 : 0,
    b: customerSettings.emailBounce ? 1 : 0,
    c: customerSettings.emailVerified ? 1 : 0,
    d: customerSettings.cellPhoneVerified ? 1 : 0,
    e: customerSettings.cellPhoneExists ? 1 : 0,
    f: customerSettings.email,
    g: customerSettings.cellphone
  };
}

function mapCustomerSettingsAtGet(data) {
  return {
    emailRemoved: data.a === 1,
    emailBounce: data.b === 1,
    emailVerified: data.c === 1,
    cellPhoneVerified: data.d === 1,
    cellPhoneExists: data.e === 1,
    email: data.f,
    cellphone: data.g
  };
}

function createPlayerNotifications() {
  let clearRemindLater = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (customerSettings.emailRemoved || customerSettings.emailBounce) {
    if (customerSettings.emailRemoved && (!isShown(reminderTypes.emailMissing) && !remindLaterSet(reminderTypes.emailMissing) || clearRemindLater)) {
      logger.debug('Customer with removed email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        var _svs;
        (_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.player_notifications) === null || _svs === void 0 || (_svs = _svs.bounce_or_no_email) === null || _svs === void 0 || _svs.showMissingEmailMessage(clearRemindLater);
      });
    } else if (customerSettings.emailBounce && (!isShown(reminderTypes.emailBounced) && !remindLaterSet(reminderTypes.emailBounced) || clearRemindLater)) {
      logger.debug('Customer with bouncing email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        var _svs2;
        (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.player_notifications) === null || _svs2 === void 0 || (_svs2 = _svs2.bounce_or_no_email) === null || _svs2 === void 0 || _svs2.showEmailBounceMessage(clearRemindLater, customerSettings.email);
      });
    }
  } else if (!customerSettings.emailVerified) {
    if (customerSettings.emailVerified || !customerSettings.emailVerified && (isShown(reminderTypes.emailNotVerified) || remindLaterSet(reminderTypes.emailNotVerified) && !clearRemindLater)) {
    } else {
      logger.debug('Customer with unverified email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        var _svs3;
        (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.accountservices) === null || _svs3 === void 0 || (_svs3 = _svs3.player_notifications) === null || _svs3 === void 0 || (_svs3 = _svs3.verify_contact_info) === null || _svs3 === void 0 || _svs3.showVerifyEmailMessage(customerSettings, clearRemindLater);
      });
    }
  }
  if (!customerSettings.cellPhoneVerified) {
    if (customerSettings.cellPhoneVerified || !customerSettings.cellPhoneVerified && customerSettings.cellPhoneExists && (isShown(reminderTypes.cellphoneNotVerified) || remindLaterSet(reminderTypes.cellphoneNotVerified) && !clearRemindLater)) {
    } else {
      logger.debug('Customer with unverified cellphone');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        var _svs4;
        (_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.accountservices) === null || _svs4 === void 0 || (_svs4 = _svs4.player_notifications) === null || _svs4 === void 0 || (_svs4 = _svs4.verify_contact_info) === null || _svs4 === void 0 || _svs4.showVerifyCellPhoneMessage(customerSettings, clearRemindLater);
      });
    }
  }
}

function fetchPlayerNotifications(callback) {
  const options = {
    method: 'GET',
    path: '/player/2/customizedsettings'
  };
  let custProp;
  let contactInfoStatus;
  if (svs.utils.ns.isNamespace('svs.accountservices.player_notifications_checker.data.contactInfoStatus', window)) {
    contactInfoStatus = svs.accountservices.player_notifications_checker.data.contactInfoStatus;
  } else {
    logger.info('Constant contactInfoStatus is missing in response from server');
    return;
  }
  svs.core.jupiter.call(options, data => {
    try {
      if (data) {
        if (data.customizedSettings) {
          if (data.customizedSettings.properties) {
            custProp = data.customizedSettings.properties;
          } else {
            logger.info('Missing properties object from /player/2/customizedsettings');
            return;
          }
        } else {
          logger.info('Missing customizedsettings object from /player/2/customizedsettings');
          return;
        }
      } else {
        logger.error('Empty response object from /player/2/customizedsettings');
        return;
      }
    } catch (e) {
      logger.error('Error parsing server response:', e);
      return;
    }
    customerSettings.emailRemoved = custProp.emailStatus === contactInfoStatus.deleted || custProp.emailStatus === contactInfoStatus.offeredVerificationExpired;
    customerSettings.emailBounce = custProp.emailStatus === contactInfoStatus.bounce;
    customerSettings.emailVerified = custProp.emailStatus === contactInfoStatus.verified || custProp.emailStatus === contactInfoStatus.notOfferedVerification;
    customerSettings.cellPhoneVerified = custProp.cellPhoneStatus === contactInfoStatus.verified || custProp.cellPhoneStatus === contactInfoStatus.notOfferedVerification;
    customerSettings.cellPhoneExists = Boolean(custProp.cellphone);
    customerSettings.email = custProp.email;
    customerSettings.cellphone = custProp.cellphone;
    svs.core.userSession.set('playerNotifs_customerSettings', mapCustomerSettingsForSave(), error => {
      if (error) {
        logger.info('Error setting customer settings in userSession, ', error);
        if (customerSettings) {
          callback && callback();
        }
      } else {
        callback && callback();
      }
    });
  }, xhr => {
    logger.info('Error getting users customized settings, ', xhr);
  });
}

function checkPlayerNotifications() {
  svs.core.userSession.get('playerNotifs_customerSettings', (error, data) => {
    if (error) {
      logger.info('Error getting customer settings from userSession, ', error);
    } else if (data) {
      customerSettings = mapCustomerSettingsAtGet(data); 
      logger.debug("Getted data from userSession: ".concat(JSON.stringify(customerSettings)));
      createPlayerNotifications();
    } else {
      fetchPlayerNotifications(createPlayerNotifications);
    }
  });
}

function checkEmail() {
  if (!isShown(reminderTypes.emailNotVerified)) {
    if (customerSettings.emailRemoved) {
      logger.debug('Customer with removed email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        svs.accountservices.player_notifications.bounce_or_no_email.showMissingEmailMessage(true);
      });
    } else if (customerSettings.emailBounce) {
      logger.debug('Customer with bouncing email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        svs.accountservices.player_notifications.bounce_or_no_email.showEmailBounceMessage(true, customerSettings.email);
      });
    } else if (!customerSettings.emailVerified) {
      logger.debug('Customer with unverified email');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        svs.accountservices.player_notifications.verify_contact_info.showVerifyEmailMessage(customerSettings, true);
      });
    }
  }
}

function checkCellphone() {
  if (!isShown(reminderTypes.cellphoneNotVerified)) {
    if (!customerSettings.cellPhoneVerified && customerSettings.cellPhoneExists) {
      logger.debug('Customer with unverified cellphone');
      svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
        svs.accountservices.player_notifications.verify_contact_info.showVerifyCellPhoneMessage(true);
      });
    }
  }
}

function unShow(type) {
  logger.debug('Remove specific type of unverified contact info from shown array');
  if (shownTypes) {
    const types = shownTypes.filter(reminderType => reminderType !== type).concat([]);
    shownTypes = types;
  }
}

function closeToaster() {
  logger.debug('Close previous toaster');
  try {
    for (const key in svs.accountservices.player_notifications_checker.toaster) {
      if (svs.accountservices.player_notifications_checker.toaster.hasOwnProperty(key)) {
        svs.accountservices.player_notifications_checker.toaster[key].close();
      }
    }
  } catch (e) {
    logger.debug('svs.accountservices.player_notifications_checker.toaster not available');
  }
}

function clearShownTypes() {
  logger.debug('Remove all types of unverified contact info from shown array');
  shownTypes = [];
}

function refreshCustomerSettings() {
  logger.debug('Refresh customer settings');
  if (refreshRetries == 0) {
    oldCustomerSettings = Object.assign(oldCustomerSettings, customerSettings);
  }
  if (refreshRetries === refreshMaxRetries || JSON.stringify(customerSettings) != JSON.stringify(oldCustomerSettings)) {
    refreshRetries = 0;
    oldCustomerSettings = {};
  } else {
    refreshRetries++;
    setTimeout(() => {
      fetchPlayerNotifications(refreshCustomerSettings);
    }, refreshRetryDelay);
  }
}

playerNotificationsCheckerEvents.on('email', () => {
  logger.debug('Event email triggered');
  checkEmail();
});

playerNotificationsCheckerEvents.on('cellphone', () => {
  logger.debug('Event cellphone triggered');
  checkCellphone();
});

playerNotificationsCheckerEvents.on('refresh', () => {
  logger.debug('Event refresh triggered');
  refreshCustomerSettings();
});

playerNotificationsCheckerEvents.on('reset', () => {
  logger.debug('Event reset triggered');

  svs.core.userSession.remove('playerNotifs_remindLater', () => {
    refreshCustomerSettings();
  });
});

playerNotificationsCheckerEvents.on('clear', () => {
  logger.debug('Event clear triggered');

  svs.core.userSession.remove('playerNotifs_customerSettings', () => {
    svs.core.userSession.remove('playerNotifs_remindLater', () => {
      clearShownTypes();
      closeToaster();
      logger.debug('Cleared cache for customer settings and remind later');
    });
  });
});
try {
  Backbone.history.on('route', () => {
    logger.debug('Backbone navigation. Hide previous toaster and re-check player notifications');
    setTimeout(() => {
      checkPlayerNotifications();
    }, 500);
  });
} catch (e) {
  logger.debug('No backbone at this page');
}

function closeToasters() {
  logger.debug('Close all toasters');
  for (const key in svs.accountservices.player_notifications_checker.toaster) {
    if (svs.accountservices.player_notifications_checker.toaster[key]) {
      svs.accountservices.player_notifications_checker.toaster[key].close();
    }
  }
}
const checkPlayerVerifiedEmailForSubscription = function () {
  let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Object.keys(customerSettings).length === 0) {
    logger.debug('Fetching player notifications before checking email verification for subscription');
    fetchPlayerNotifications(() => {
      checkPlayerVerifiedEmailForSubscription(settings);
    });
    return;
  }
  if (customerSettings.emailVerified) {
    var _settings$onContinue;
    settings === null || settings === void 0 || (_settings$onContinue = settings.onContinue) === null || _settings$onContinue === void 0 || _settings$onContinue.call(settings);
    return;
  }
  svs.core.module.load('/cl/accountservices/player-notifications', null, () => {
    var _svs5;
    (_svs5 = svs) === null || _svs5 === void 0 || (_svs5 = _svs5.accountservices) === null || _svs5 === void 0 || (_svs5 = _svs5.player_notifications) === null || _svs5 === void 0 || (_svs5 = _svs5.verify_contact_info) === null || _svs5 === void 0 || _svs5.showVerifyEmailMessage(customerSettings, false, _objectSpread({
      isSubscription: true
    }, settings));
  });
  return true;
};
svs.accountservices.player_notifications_checker = _objectSpread(_objectSpread({}, svs.accountservices.player_notifications_checker), {}, {
  checkPlayerNotifications,
  remindLaterSet,
  reminderTypes,
  unShow,
  events: playerNotificationsCheckerEvents,
  toaster: {},
  customerSettings: () => customerSettings,
  shownTypes: () => shownTypes,
  closeToasters,
  fetchPlayerNotifications,
  checkPlayerVerifiedEmailForSubscription
});
svs.accountservices.player_notifications_checker.test = {
  createPlayerNotifications
};

 })(window);